import { useContext, useEffect, useState } from 'react';
import { set, useForm } from 'react-hook-form';
import { AppContext } from '../../../hooks/auth/useAppContext';
import { useStandardCall } from '../../../hooks/useStandardCall';
import SingleInput from '../../../components/SingleInput';
import { LocalLoading } from '../../../components/Loading';
import { toast } from 'react-toastify';

export function UserSecurityTabComponent() {
  const stdCall = useStandardCall();
  const [resource, setResourse] = useState(TheApp.Res);
  const appContext = useContext(AppContext);
  const [statusForm, setStatusForm] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors }
  } = useForm();


  const inputs = [
    {
      id: 'old_password',
      label: resource["Form.OldPassword"] ?? 'Vecchia password',
      type: 'password',
      validationSchema: {
        required: resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
      },
      placeholder: resource["Form.OldPassword.Placeholder"] ??  'Inserisci la vecchia password',
      layout: 'col-lg-12 col-md-6',
      icon: 'fas fa-lock',
      defaultValue: ''
    },
    {
      id: 'new_password',
      label: resource["Form.NewPassword"] ?? 'Nuova password',
      type: 'password',
      defaultValue: '',
      validationSchema: {
        required: resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
        pattern: {
          value:
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@!£$%&=<>|])([^\s]){8,20}$/,
          message:
            resource["Form.NewPassword.Pattern"] ?? 'La password deve contenere almeno 8 caratteri, una lettera maiuscola, una minuscola, un numero e un carattere speciale'
        }
      },
      placeholder: resource["Form.NewPassword.Placeholder"] ??  'Inserisci la nuova password',
      icon: 'fa fa-lock',
      layout: 'col-lg-12 col-md-6'
    },
    {
      id: 'ConfirmPassword',
      label: resource["Form.PwdConfirm"] ?? 'Conferma Password',
      type: 'password',
      toCompare: true,
      defaultValue: '',
      validationSchema: {
        required: resource["Form.RequiredLabel"] ?? "Campo obbligatorio",
        validate: {
          matchPreviousValue: (value) => {
            const { new_password } = getValues();
            return new_password === value || (resource["Form.PwdConfirm.Pattern"] ??  'Le password non coincidono');
          }
        }
      },
      placeholder: resource["Form.PwdConfirmPlaceholder"] ?? 'Conferma la tua password',
      icon: 'fa fa-lock',
      layout: 'col-lg-12 col-md-6'
    }
  ];
  function updatePassword(data) {
    const { old_password, new_password } = data;
    const rq = {
      old_password,
      new_password
    };
    appContext._setters._setLoading(true);
    stdCall.post('auth/passwordchange', rq, (rs) => {
      if (rs.Success) {
        setStatusForm({
          status: true,
          message: resource["Form.UpdatePassword.Success"] ?? 'Password aggiornata con successo',
          success: true
        });
        reset();
      } else {
        console.log('error', rs.Message);
        setStatusForm({
          status: true,
          message: rs.Message,
          success: false
        });
      }
    }).catch(error => {
      setStatusForm({
        status: true,
        message: resource["Form.GenericError"] ?? `Si è verificato un errore, riprova più tardi.`,
        success: false
      });
    })
    .finally(() => {
		appContext._setters._setLoading(false);
    });
  }

  useEffect(() => {
    if (statusForm) {
      if (statusForm?.success) {
        toast.success(statusForm?.message);
      }
      if (!statusForm?.success) {
        toast.error(statusForm?.message);
      }
    }
  }, [statusForm]);


  useEffect(() => {
    setResourse(TheApp.Res[TheApp.Locale]);
  }, [resource]);

  return (
    <div className="wrapper-form">
      <form onSubmit={handleSubmit(updatePassword)}>
        <div className="row">
          {inputs.map((input) => (
            <SingleInput
              key={input.id}
              errors={errors}
              register={register}
              setValue={setValue}
              {...input}
            />
          ))}
          <div className="col-lg-12 col-md-6">
            <input
              type="submit"
              value={resource["Form.UpdatePassword.Submit"] ?? `Cambia Password`}
              className="btn primary"
            />
          </div>
        </div>
      </form>
    </div>
  );
}
